import { Listing, MarketplaceEarning } from 'src/api/v1-api';
import { useMarketplaceContext } from 'src/contexts/marketplace';
import { getListingUrl } from 'src/utils/marketplaceUtils';
import MarketplaceEarningItem from 'src/components/atoms/marketplace-earning-item';

interface MarketplaceEarningPaidAffiliateTransactionProps {
  earning: MarketplaceEarning;
  showImage?: boolean;
}

const MarketplaceEarningPaidAffiliateTransaction = ({
  earning,
  showImage = false,
}: MarketplaceEarningPaidAffiliateTransactionProps) => {
  const { urlBase } = useMarketplaceContext();
  const { listing_id, client_account_id } = earning.metadata;
  const listing: Listing = earning.earning_object;

  const listingImage = (listing?.listing_images ?? [])[0];
  const listingUrl = getListingUrl(urlBase, listing_id);

  return (
    <MarketplaceEarningItem
      earningDate={earning.invoice_date}
      earningTitle="Paid Affiliate Transaction"
      earningAmount={earning.amount}
      earningItemUrl={listingUrl}
      earningImageUrl={listingImage?.image}
      showImage={showImage}
      clientAccountId={client_account_id}
      earningMetadata={[
        {
          title: 'Source',
          value: listing?.source ?? '',
          displayTitle: true,
        },
      ]}
    />
  );
};

export default MarketplaceEarningPaidAffiliateTransaction;
